module.exports = __webpack_public_path__ + "static/media/additionalServices.cb89bf18.jpg";